"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.InboundShipmentErrorMessage = exports.InboundShipmentErrorCode = void 0;
var InboundShipmentErrorCode;
(function (InboundShipmentErrorCode) {
    InboundShipmentErrorCode["SHIPMENT_SELLERID_MISMATCH"] = "SHIPMENT_SELLERID_MISMATCH";
    InboundShipmentErrorCode["SHIPMENT_STATUS_UNEXPECTED"] = "SHIPMENT_STATUS_UNEXPECTED";
    InboundShipmentErrorCode["SHIPMENT_DSKU_UNEXPECTED"] = "SHIPMENT_DSKU_UNEXPECTED";
})(InboundShipmentErrorCode = exports.InboundShipmentErrorCode || (exports.InboundShipmentErrorCode = {}));
exports.InboundShipmentErrorMessage = {
    SHIPMENT_SELLERID_MISMATCH: "shipment does not belong to this seller",
    SHIPMENT_STATUS_UNEXPECTED: "shipment status does not match expected status",
    SHIPMENT_DSKU_UNEXPECTED: "unexpected dskus are in this shipment",
};
//# sourceMappingURL=ShipmentError.js.map